module.exports = __webpack_public_path__ + "static/pattern-1c4a01634f9d605bb88d4f8e7a546566.jpg";